module.exports = __webpack_public_path__ + "img/avatar-2.5ba3aa96.png";